import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';
import { AI_AUTOMATIONS_LOCAL_API_REQUESTS } from './constants';

/**
 * POST /nerobotti/automations — one new scheduled task.
 *
 * There is no field for who it runs as. The server takes that from the signed
 * request, so a task always acts with the permissions of whoever created it.
 */
export const createAutomation = async ({
  businessId,
  kind,
  schedule,
  projectSelection,
  customInstructions,
}) => {
  const signedRequest = await createSignedPostRequest({
    apiPath: 'nerobotti/automations',
    body: {
      businessId,
      kind,
      schedule,
      projectSelection,
      ...(customInstructions ? { customInstructions } : {}),
    },
    isLocalApiRequest: AI_AUTOMATIONS_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
